<template>
  <v-input
    :error-messages="errors"
    :hide-details="dense"
    :rules="rules"
  >
    <div>
      <v-label>{{ field.label }}</v-label>

      <v-checkbox
        v-for="option in (field.options || [])"
        :key="getOptionKey(option)"
        v-model="innerValue"
        density="compact"
        hide-detailsm
        :label="option.text"
        :value="option.value"
      />
    </div>
  </v-input>
</template>

<script setup lang="ts">
const props = defineProps<{
  field: FieldConfig
  rules?: FormRule[]
  errors?: string[]
  dense?: boolean
  modelValue: unknown[]
}>();
const emit = defineEmits(['update:modelValue']);

const innerValue = ref<unknown[]>(props.modelValue || []);
watch(innerValue, newValue => emit('update:modelValue', newValue));
const getOptionKey = (option: ChoiceOption) => option.value as string;
</script>
